export const LOG_IN = "app/LOG_IN";
export const LOG_OUT = "app/LOG_OUT";
export const RESET_APP = "app/RESET_APP";
export const SYNC_INIT = "app/SYNC_INIT";
export const SYNC_SUCCESS = "app/SYNC_SUCCESS";
export const SYNC_FAILURE = "app/SYNC_FAILURE";
export const TOGGLE_MENU = "app/TOGGLE_MENU";

export interface AppState {
  loggedIn: boolean;
  isSyncing: boolean;
  successSyncing: boolean;
  errorSyncing: Error | null;
  menuOpen: boolean;
}

interface LogInAction {
  type: typeof LOG_IN;
}

interface LogOutAction {
  type: typeof LOG_OUT;
}

interface ResetAppAction {
  type: typeof RESET_APP;
}

interface SyncInitAction {
  type: typeof SYNC_INIT;
}

interface SyncSuccessAction {
  type: typeof SYNC_SUCCESS;
}

interface SyncFailureAction {
  type: typeof SYNC_FAILURE;
  error: Error;
}

interface ToggleMenuAction {
  type: typeof TOGGLE_MENU;
  open: boolean;
}

export type AppActionTypes =
  | LogInAction
  | LogOutAction
  | ResetAppAction
  | SyncInitAction
  | SyncSuccessAction
  | SyncFailureAction
  | ToggleMenuAction;
